<template>
    <div class="flex flex-wrap sm:flex-nowrap">
        <div class="w-full sm:w-2/3 md:w-3/4 sm:mr-6 md:mr-20">
            <div class="flex flex-wrap">
                <a
                    v-for="(ticketType, index) in ticketTypes"
                    :key="index"
                    class="package block border border-solid bg-white rounded-xl p-4"
                    :class="{
                        'package-selected': selectedPackageIndex == index,
                        'sold-out': ticketType.available < 1
                    }"
                    @click="onClickPackage(index)"
                >
                    <div class="title">
                        {{ ticketType.type }}
                    </div>
                    <template
                        v-if="
                            ticketType.enquiry_enabled != 1 &&
                                (ticketType.enquiry_enabled != 2 || ticketType.available >= 1)
                        "
                    >
                        <div class="price text-gray-500">
                            &pound;{{ ticketType.price_human }}<br />
                            <span class="capitalize">per {{ ticketType.noun || "person" }}</span>
                        </div>
                        <div class="remaining">
                            <template v-if="ticketType.available">
                                {{ ticketType.available.toLocaleString("en", { useGrouping: true }) }} Tickets Remaining
                            </template>
                            <template v-else>
                                Sold Out
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <div class="price text-gray-500">
                            Price TBC
                        </div>
                        <div class="remaining">
                            <template>
                                Enquire Now
                            </template>
                        </div>
                    </template>
                </a>
            </div>
            <template v-if="selectedTicketType.description">
                <h2>Included In This Package</h2>
                <div v-html="selectedTicketType.description"></div>
            </template>
        </div>
        <div class="w-full sm:w-1/3 md:w-1/4">
            <div class="flex flex-wrap">
                <div class="my-1 px-1 w-full">
                    <ticket-type-add-to-basket :ticketType="selectedTicketType" :scheduleId="scheduleId">
                        <template v-slot:purchase-block-header-image>
                            <slot name="purchase-block-header-image"></slot>
                        </template>
                        <template v-slot:purchase-block-header>
                            <slot name="purchase-block-header"></slot>
                        </template>
                        <template v-slot:purchase-block-footer>
                            <slot name="purchase-block-footer"></slot>
                        </template>
                    </ticket-type-add-to-basket>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TicketTypeAddToBasket from "./ticket-type-add-to-basket.vue";
export default {
    components: { TicketTypeAddToBasket },
    props: {
        ticketTypes: {
            type: Array,
            required: true
        },
        scheduleId: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        website: window.website,
        currency: window.currency,
        loading: true,
        selectedPackageIndex: 0
    }),
    mounted() {},
    methods: {
        onClickPackage(index) {
            this.selectedPackageIndex = index;
        }
    },
    computed: {
        selectedTicketType: function() {
            if (!this.selectedPackageIndex) this.selectedPackageIndex = 0;
            return this.ticketTypes[this.selectedPackageIndex];
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../sass/base/_variables.scss";
@import "../../sass/mixins/_box-model.scss";
@import "../../sass/mixins/_breakpoint.scss";
@import "../../sass/mixins/_transforms.scss";

.package {
    border-color: rgba(209, 213, 219, 1);

    &.package-selected {
        border-color: rgba(31, 41, 55, 1);
    }

    &.sold-out {
        opacity: 0.55;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/package-selector.vue